import styled from "styled-components/macro";

export const SettingBoxScroll = styled.div`
  overflow-y: scroll;
  min-width: 100%;
  height: 100%;
  background: var(--clr-settingsbg);

  ::-webkit-scrollbar {
    width: 8px; /* Width of the scrollbar */
  }

  ::-webkit-scrollbar-track {
    /* background-color: inherit;  */
  }

  ::-webkit-scrollbar-thumb {
    background-color: lightgray;
    border-radius: 5px; /* Rounded corners of the thumb */
  }

  ::-webkit-scrollbar-thumb:hover {
    background-color: #555; /* Color of the thumb on hover */
  }

  ::-webkit-scrollbar-thumb:active {
    background-color: #000; /* Color of the thumb when active */
  }

  > div:last-child {
    border-bottom: none;
  }

  > button:last-child {
    border-bottom: none;
  }

  > a:last-child {
    border-bottom: none;
  }
`;

export const MenuItem = styled.div`
  /* see if position relative causes any problems. created this for aside for "linkinfo" page */
  position: relative;
  border-bottom: 1px solid #f6f6f635;
  color: ${({ gray }) => (gray ? "var(--clr-settingsfontgray)" : "#edebeb")};
  background-color: none;
  padding: 0.75em;
  cursor: ${({ gray }) => (gray ? "not-allowed" : "pointer")};

  &:hover {
    background: ${({ gray }) => (gray ? "none" : "gray")};
  }
`;

export const MenuItemButton = styled.button`
  width: 100%;
  position: relative;
  border: none;
  text-align: left;
  border-bottom: 1px solid #f6f6f635;
  background-color: inherit;
  /* font-size: 1rem; */
  background-color: none;
  padding: 0.75em;
  color: #edebeb;
  cursor: pointer;

  &:hover {
    background: gray;
    outline: none;
    border: none;
  }
  &:focus {
    background: gray;

    /* background: #1f729f; */
    outline: none;
    border: none;

    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.4);

    - button {
      border-bottom: none;
    }
  }
`;

export const MenuItemLabel = styled.div`
  font-size: 0.75em;
  margin-bottom: 0.6em;
  color: gray;
  padding-left: ${({ indent }) => (indent ? "1em" : "none")};
`;

export const MenuItemAside = styled.div`
  position: absolute;
  right: 10%;
`;

export const MenuImageContainer = styled.div`
  width: 60%;
`;
export const MenuImage = styled.img`
  /* object-fit: fill; */
  width: 100%;
  height: auto;
  padding: 0px 1em;
`;

export const MenuIconContainer = styled.div`
  display: flex;
  /* text-align: center; */
  align-items: center;
  justify-content: center;
  position: absolute;
  left: 0%;
  top: 0%;
  width: 100%;
  height: 100%;
`;

export const MenuIconText = styled.div`
  /* height: 20px; */
`;

export const MenuIconWrapper = styled.div`
  height: ${({ flexend }) => (flexend ? "70%" : "45%")};
  /* height */
  margin-left: ${({ flexend }) => (flexend ? "auto" : "2em")};
  justify-self: ;
`;
export const MenuIcon = styled.img`
  margin-left: auto;
  /* width: 100%; */
  /* height: auto; */
  padding-left: 1em;
  /* height: 20px; */
`;

// alarm button

export const MenuPauseAlarmBtn = styled.button`
  color: #edebeb;
  text-align: center;

  height: 15%;
  width: 95%;
  margin: 0.5em auto;
  padding: 0.35em;
  background-color: #6d6868;

  display: flex;
  justify-content: center;
  align-items: center;
  gap: 1em;
`;

export const MenuPauseAlarmIcon = styled.div`
  margin-top: 0.12em;
`;

//save button (op modes)
export const Configbox = styled.div`
  position: relative;
`;
export const SaveButton = styled.button`
  padding: 1em 1.5em;
  border: #414340;

  background: gray;

  color: #edebeb;
  border-top-left-radius: 7px;
  border-bottom-left-radius: 7px;
  color: #edebeb;

  position: absolute;
  top: -20%;
  right: 5%;
  border-top-right-radius: 2px;
  border-bottom-right-radius: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
  background-color: #1f729f;
  padding: 0.5em 1.5em;
`;
